<tilby-dialog-toolbar mat-dialog-title
    [title]="'HISTORY.REFUND_ITEMS_SELECTOR.TITLE'"
    (confirm)="check()"
    [disabled]="hasCheckDisabled()"
>
    <div class="tw-flex tw-h-6 tw-items-center tw-justify-end tw-font-bold tw-flex-grow" toolbar-content>
        <app-barcode (onSubmitBarcode)="onBarcodeScanned($event)" [idSelector]="'barcodeInputdialog'"></app-barcode>
        <app-barcode-scanner (onBarcodeScannedChange)="onBarcodeScanned($event)" [topbarMode]="true"></app-barcode-scanner>
    </div>
</tilby-dialog-toolbar>
<div class="tw-flex tw-justify-center tw-mb-3">
    <button class="tw-mr-4" mat-stroked-button color="primary" (click)="unselectAll()">
        <span translate>HISTORY.REFUND_ITEMS_SELECTOR.UNSELECT_ALL</span>
    </button>
    <button mat-stroked-button color="primary" (click)="selectAll()">
        <span translate>HISTORY.REFUND_ITEMS_SELECTOR.SELECT_ALL</span>
    </button>
</div>
<tilby-dialog-content>
    <cdk-virtual-scroll-viewport appendOnly itemSize="50" [ngClass]="[isMobile ? 'tw-min-h-[calc(100vh-205px)]' : 'tw-min-h-[50vh]']">
        <div *cdkVirtualFor="let item of saleItems" class="tw-flex tw-flex-row tw-mb-4">
            <div>
                <mat-form-field appearance="fill" class="tw-mr-4 tw-w-40">
                    <mat-label translate>HISTORY.REFUND_ITEMS_SELECTOR.QUANTITY</mat-label>
                    <mat-select [(ngModel)]="item._quantity">
                        @for(qty of item._quantities; track qty) {
                            <mat-option [value]="qty">{{qty}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="tw-flex-col tw-w-full">
                <div class="tw-flex-row tw-flex tw-justify-between">
                    <span class="tw-flex">{{item.name}}</span>
                    <span>{{(item.final_price * item.quantity) | tilbyCurrency}}</span>
                </div>
                <div class="tw-flex tw-flex-col tw-overflow-y-auto tw-text-xs tw-text-gray-600">
                    @for(variation of item.variations; track variation) {
                        <span>{{ variation.name }} - {{ variation.value }}</span>
                    }
                    @for(ingredient of item.ingredients; track ingredient) {
                        <span>{{ ingredient.type === 'removed' ? '-' : '+' }} {{ ingredient.quantity !== undefined && ingredient.quantity > 1 ? ingredient.quantity + 'x' : '' }} {{ ingredient.name }}</span>
                    }
                    @if(item.notes) {
                        <span>{{item.notes}}</span>
                    }
                </div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</tilby-dialog-content>
